<div class="max-w-sm bg-white border border-primary p-3 flex flex-col gap-1">
    <div class="flex flex-row gap-5 items-center mb-3">
        <h3 class="mb-0" i18n>Existing attributes</h3>
        <button class="btn btn-ghost btn-circle" (click)="afterClose.emit()">
            <iota-icon icon="x-mark" size="2"></iota-icon>
        </button>
    </div>
    <ng-container *ngFor="let attributeKey of attributeKeys">
        <div (click)="selectAttributeName($event)">
            {{ attributeKey }}
        </div>
    </ng-container>
</div>
